<template>
  <!-- 主题结构 -->
  <div>
    <!-- 头部导航 -->
    <div class="header clearfix">
      <!-- 功能导航 -->
      <div class="le fl">
        <Menu
          mode="horizontal"
          ref="menuNav"
          :active-name="menuList_active"
          @on-select="menuList_select"
        >
          <MenuItem
            :name="index"
            v-for="(item, index) in MenuList"
            :key="index"
          >
            <Icon type="ios-paper" />
            {{ item.title }}
          </MenuItem>
        </Menu>
      </div>
      <!-- 功能按钮 -->
      <div class="ri fr clearfix">
        <!-- 门店 -->
        <div class="city mt16 mr20 fl">
          <Select
            transfer
            v-model="city"
            style="width:120px"
            @on-change="select_city"
          >
            <Option v-for="item in cityList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </div>
        <!-- 消息 -->
        <!-- <div class="message mt16 mr20 fl">
                    <div class="message-min">
                        <Badge dot>
                            <Tooltip content="无未读消息" placement="bottom">
                                <Icon type="ios-volume-down" />消息中心
                            </Tooltip>
                        </Badge>
                    </div>
                </div>-->
        <!-- 商户管理员 -->
        <!-- <div class="head-right-user mt20 mr20 fl">
          <Dropdown>
            <a href="javascript:void(0)">
              商户管理员
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem>驴打滚</DropdownItem>
            </DropdownMenu>
          </Dropdown>
                </div>-->
        <!-- 登录用户 -->
        <div class="head-right-user mt20 mr20 fl">
          <Dropdown @on-click="user_changeMenu">
            <a href="javascript:void(0)">
              {{ this.$store.state.user.admin_info.realname }}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="change">修改密码</DropdownItem>
              <DropdownItem name="out">退出登录</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>

    <!-- 侧边栏 -->
    <div class="sidebar-menu-con">
      <div class="logo" style="cursor:pointer;" @click="goHome">后台管理系统</div>
      <!-- <div class="logo" v-if="cityList.length>0">{{cityList.find(i=>i.id==city).name}}</div> -->
      <Menu
        theme="dark"
        accordion
        ref="sidebarLeft"
        :open-names="[MenuOpen]"
        :active-name="MenuActive"
        class="sidebar-menu-con-box"
        @on-select="sidebar_left"
        @on-open-change="sidebar_left_menu"
      >
        <div
          v-show="menuList_active == index"
          v-for="(item, index) in MenuList"
          :key="index"
        >
          <template v-for="(items, ind) in item.children">
            <Submenu
              :name="items.id"
              v-if="items.children && items.children.length > 0"
              :key="ind"
            >
              <template slot="title">
                <!-- <Icon type="ios-paper" /> -->
                {{ items.title }}
              </template>
              <MenuItem
                :name="list.id"
                :to="list.path"
                v-for="(list, index2) in items.children"
                :key="index2"
                >{{ list.title }}</MenuItem
              >
            </Submenu>
            <MenuItem :name="items.id" v-else :key="ind" :to="items.path">{{
              items.title
            }}</MenuItem>
          </template>
        </div>
      </Menu>
    </div>
    <!-- 主题内容 -->
    <div class="single-page-con">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "main_main",
  data() {
    return {
      //当前门店
      city: "",
      // 门店列表
      cityList: [],
      // 导航列表
      MenuList: [],
      // 导航列表选中
      menuList_active: 0,
      // 侧边栏展开项
      MenuOpen: 0,
      // 侧边栏选中子菜单
      MenuActive: ""
    };
  },
  created: function() {
    this.getCityList();
    this.getMenuList();
  },
  mounted: function() {
    // this.getBread();
  },
  methods: {
    ...mapActions([
      "menu_type",
      "SetCity",
      "LogOut",
      "SetCityTwo",
      "SetDomain"
    ]),
    goHome() {
      this.$router.push({
        name: "_home"
      });
    },
    // 切换导航
    menuList_select(name) {
      console.log("切换导航");
      var key = "menu_nav";
      var data = name;
      this.menu_type({ key, data });
      this.menuList_active = name;
    },
    // 侧边栏子项
    sidebar_left(name) {
      var key = "menu_left_name";
      var data = name;
      this.menu_type({ key, data });
    },
    // 侧边栏展开
    sidebar_left_menu(name) {
      var key = "menu_left";
      var data = name[0];
      this.menu_type({ key, data });
    },
    // 切换门店列表
    select_city(val,index) {
      this.$Modal.confirm({
        title: "切换门店",
        content: "<p>您确认需要切换门店站点吗?</p>",
        onOk: () => {
          var value = val;
          this.SetCity({ value });
          this.city = val;
          var key = "spinShow";
          var data = true;
          this.menu_type({ key, data });
          this.$store.state.app.spinShow = true;
          
          let img = this.cityList.find(item =>item.id == val).image
          localStorage.setItem("userImg", img); // 设置头像
        },
        onCancel: () => {
          this.city = Number(this.$store.state.user.organ_id);
        }
      });
    },
    // 根据门店id获取门店
    organ_name(id) {
      let _this = this;
      for (let i = 0; i < _this.cityList.length; i++) {
        if (id == _this.cityList[i].id) {
          var value = _this.cityList[i].name;
          var domain = _this.cityList[i].domain;
          _this.SetCityTwo({ value });
          _this.SetDomain({ domain });
        }
      }
    },
    // 用户操作
    user_changeMenu: function(name) {
      if (name == "out") {
        // this.http.get("index/index").then(res => {
        this.LogOut({}).then(() => {
          this.$router
            .push({
              name: "/login"
            })
            .catch(err => {});
        });
        // });
      } else if (name == "change") {
        this.$router.push("/forgetPassword");
      }
    },
    // 获取门店列表
    getCityList() {
      this.http.get(this.API.getCityList).then(res => {
        if (res.code == 200) {
          this.cityList = res.data;
          this.city = Number(this.$store.state.user.organ_id);
          this.organ_name(this.$store.state.user.organ_id);
        }
      });
    },
    // 获取栏目列表
    getMenuList() {
      this.http.post(this.API.getMenuList).then(res => {
        if (res.code == 200) {
          this.MenuList = res.data;
          // 导航列表选中
          this.menuList_active = Number(this.$store.state.app.menu_nav);
          // 侧边栏展开项
          var arr = [];
          if (this.$store.state.app.menu_left) {
            var id = this.$store.state.app.menu_left;
            this.MenuOpen = Number(id);
          }
          // 侧边栏选中子菜单
          this.MenuActive = Number(this.$store.state.app.menu_left_name);
          this.$nextTick(() => {
            this.$refs.menuNav.updateActiveName();
            this.$refs.sidebarLeft.updateOpened();
            this.$refs.sidebarLeft.updateActiveName();
          });
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      // console.log(from.meta.breadcrumb)
      // console.log(from.meta.breadcrumb)
    }
  }
};
</script>
<style>
.Tab-box .ivu-tabs-bar {
  border: none;
  margin-top: 10px;
}
.Tab-box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 4px;
  border: 1px solid #dcdee2;
}
</style>

<style scoped>
.header {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: fixed;
  display: block;
  width: 100%;
  z-index: 20;
  -webkit-box-shadow: 0 2px 1px 1px hsla(0, 0%, 39.2%, 0.1);
  box-shadow: 0 2px 1px 1px hsla(0, 0%, 39.2%, 0.1);
  -webkit-transition: padding 0.3s;
  transition: padding 0.3s;
  height: 64px;
  padding-left: 250px;
  background-color: #ffffff;
}
.ivu-menu-horizontal.ivu-menu-light:after {
  background-color: transparent;
}
.header .ri {
  float: right;
  height: 64px;
  margin-right: 30px;
}
.message-min .ivu-icon {
  font-size: 30px;
  vertical-align: middle;
}
.head-right-user a {
  color: #515a6e;
}
/* 侧边栏 */
.sidebar-menu-con {
  height: 100%;
  width: 240px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 21;
  -webkit-transition: width 0.3s;
  transition: width 0.3s;
  background: #3b4144;
}
.sidebar-menu-con .logo {
  width: 100%;
  height: 64px;
  line-height: 64px;
  text-align: center;
  font-size: 28px;
  color: #ffffff;
  background: #25282a;
}
.sidebar-menu-con .ivu-menu-dark {
  background: #3b4144 !important;
}
.ivu-menu-submenu-title {
  background: transparent !important;
}
/* 主题内容 */
.single-page-con {
  min-width: 770px;
  position: absolute;
  top: 100px;
  right: 0;
  bottom: 0;
  left: 240px;
  margin: 10px;
  margin-top: -36px;
  background-color: #f0f0f0;
  z-index: 1;
  -webkit-transition: left 0.3s;
  transition: left 0.3s;
}
</style>
<style>
/* .sidebar-menu-con-box.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title{
    background-color: #3b4144;
}
.sidebar-menu-con-box.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title:hover{
    background-color: #3b4144;
}
.sidebar-menu-con-box.ivu-menu-vertical .ivu-menu-submenu-title:hover{
    background-color: #3b4144;
} */
.sidebar-menu-con-box.ivu-menu-vertical .ivu-menu-opened {
  background-color: #25282a;
}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue